import { useIntl } from "react-intl";
import { Divider, Grid, Segment } from "semantic-ui-react";
import { CreativesTabsMenu } from "../../form/common/creativesTabsMenu";

export const CreativesHeader = ({ creativeType }) => {
  const intl = useIntl();

  return (
    <Segment
      basic
      style={{ padding: "0" }}
    >
      <h1>
        {intl.formatMessage({
          id: "HEADING_CREATIVES",
          defaultMessage: "Creatives",
        })}
      </h1>

      <Divider hidden />

      <Grid className="common_grid">
        <Grid.Row>
          <Grid.Column>
            <CreativesTabsMenu creativeType={creativeType} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default CreativesHeader;
